import React, { FC } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import styled, { StyledProps } from 'styled-components'
import { EColorBgText, sv } from '@ucheba/utils/helpers/styles/variables'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import ImgClock from '../assets/img__clock.png'
import ImgMac from '../assets/img__1_desktop.png'
import { ITimerBannerNewYearDefault } from '../types'
import Icon from '../assets/icon__check.png'

const Block = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  display: flex;
  border-radius: 8px;
`

const Content = styled.div`
  width: 65%;
  padding: 24px 32px;
`

const ImgWrap = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const Img = styled.img`
  max-width: 395px;
  height: 274px;
`

const TimeWrap = styled.div`
  border-radius: 4px;
  overflow: hidden;
  min-width: 262px;
  display: flex;
  justify-content: space-between;
  color: ${sv.color.black};
`

const TimeBlock = styled.div`
  background-color: white;
  min-width: 64px;
  padding: 8px 4px;
  margin: 0 2px;

  :first-child {
    margin: 0 2px 0 0;
  }

  :last-child {
    margin: 0 0 0 2px;
  }
`

const TimeValue = styled.div`
  font-size: ${sv.fontSize.h1};
  font-weight: ${sv.fontWeight.extrabold};
  text-align: center;
  line-height: 1;
`

const Clock = styled.img`
  width: 86px;
`

const Btn = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  color: ${(props) => sv.color[EColorBgText[props.color]]};
  padding: 20px;
  border-radius: 4px;
  height: 72px;
  margin-right: 8px;
  cursor: pointer;
`

const Title = styled.div`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: white;
`

const Wrap = styled.div<StyledProps<any>>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: ${(props) => props.marginBottom || '0'};
`

const IconCheck = styled.img`
  width: 16px;
  height: 16px;
`

const TimerBannerDefault: FC<ITimerBannerNewYearDefault> = (props) => {
  const {
    seconds,
    hours,
    days,
    minutes,
    title,
    onClick,
    show,
    color = 'gold',
    buttonColor = 'orange',
    buttonText,
    subTitle,
    discount,
    text,
    amoTag,
  } = props

  if (!title) {
    return null
  }

  return (
    <Block color={color}>
      <Content>
        {subTitle && (
          <>
            <Title>{subTitle}</Title>

            <Spacing spacing='xxsmall' />
          </>
        )}

        <Heading h2={title} spacing='null' color={EColorBgText[color]} />

        {!discount && <Spacing spacing='medium' />}

        {discount && (
          <>
            <Spacing spacing='small' />

            <Text fontSize='h3' lineHeight='h3' color='white'>
              {discount}
            </Text>

            <Spacing spacing='small' />
          </>
        )}

        {text && (
          <>
            <Grid spacing='large'>
              <GridCol width='auto'>
                {text.desktop.leftText.map((el, index) => (
                  <Wrap key={index} marginBottom='12px'>
                    <IconCheck src={Icon} />
                    <Text fontSize='large' color='white'>
                      {el}
                    </Text>
                  </Wrap>
                ))}
              </GridCol>

              <GridCol width='auto'>
                {text.desktop.rightText.map((el, index) => (
                  <Wrap key={index} marginBottom='12px'>
                    <IconCheck src={Icon} />
                    <Text fontSize='large' color='white'>
                      {el}
                    </Text>
                  </Wrap>
                ))}
              </GridCol>
            </Grid>

            <Spacing spacing='xsmall' />
          </>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {onClick && (
            <Btn
              onClick={() => {
                if (amoTag) {
                  onClick(amoTag)
                } else {
                  onClick()
                }
              }}
              color={buttonColor}
            >
              <Text fontSize='h3' lineHeight='h3' fontWeight='semibold'>
                {buttonText || 'Отправить заявку'}
              </Text>
            </Btn>
          )}

          {show && (
            <TimeWrap>
              <TimeBlock>
                <TimeValue>{days}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(days), 'день', 'дня', 'дней')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{hours}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(hours), 'час', 'часа', 'часов')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{minutes}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(minutes), 'минута', 'минуты', 'минут')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{seconds}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  секунд
                </Text>
              </TimeBlock>
            </TimeWrap>
          )}

          {!onClick && (
            <div>
              <Clock src={ImgClock} />
            </div>
          )}
        </div>
      </Content>

      <ImgWrap>
        <Img src={ImgMac} />
      </ImgWrap>
    </Block>
  )
}

export default TimerBannerDefault
